import React, { Fragment } from "react";
import { firstError, hasError } from "common/validation";
import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import CustomizableTextField from "../../general-components/CustomizableTextField";
import CustomizableSelect from "../../general-components/CustomizableSelect";
import { useTranslation } from "react-i18next";
import { useLanguages } from "../use-languages";
import PublicationDate from "./PublicationDate";
import CustomizableRichTextField from "../../general-components/CustomizableRichTextField";
import { path } from "ramda";

const ArticleDetailsFields = ({ errors, fields, onBlur, onFieldChange }) => {
  const { t } = useTranslation();
  const languages = useLanguages();

  return (
    <Fragment>
      <Grid container spacing={2}>
        <CustomizableTextField
          id="article-title"
          fieldOption="title"
          xs={12}
          sm={12}
          defaultLabel={t("file_details.title", "Title")}
          value={fields.title || ""}
          onChange={onFieldChange(["title"])}
          error={hasError(errors, "title")}
          helperText={t(firstError(errors, "title"))}
          onBlur={onBlur("title", fields.title)}
          inputProps={{ maxLength: 2048, id: "article-title" }}
        />

        <CustomizableTextField
          id="article-subtitle"
          xs={6}
          sm={6}
          fieldOption="subtitle"
          defaultLabel={t("file_details.subtitle", "Subtitle (optional)")}
          value={fields.subtitle || ""}
          onChange={onFieldChange(["subtitle"])}
          error={hasError(errors, "subtitle")}
          helperText={t(firstError(errors, "subtitle"))}
          onBlur={onBlur("subtitle", fields.subtitle)}
          inputProps={{ maxLength: 255, id: "article-subtitle" }}
        />

        <CustomizableTextField
          id="article-periodical"
          fieldOption="periodical"
          xs={6}
          sm={6}
          md={4}
          defaultLabel={t("file_details.periodical", "Periodical (optional)")}
          value={path(["periodical"], fields) || ""}
          onChange={onFieldChange(["periodical"])}
          error={hasError(errors, "periodical")}
          helperText={t(firstError(errors, "periodical"))}
          onBlur={onBlur("periodical", fields.periodical)}
          inputProps={{ maxLength: 100, id: "article-periodical" }}
        />

        <CustomizableTextField
          id="article-periodical-volume"
          fieldOption="periodicalVolume"
          xs={6}
          sm={6}
          md={4}
          defaultLabel={t(
            "file_details.perodical_volume",
            "Periodical Volume (optional)"
          )}
          value={path(["periodicalVolume"], fields) || ""}
          onChange={onFieldChange(["periodicalVolume"])}
          error={hasError(errors, "periodicalVolume")}
          helperText={t(firstError(errors, "periodicalVolume"))}
          onBlur={onBlur("periodicalVolume", fields.periodicalVolume)}
          inputProps={{ maxLength: 100, id: "article-periodical-volume" }}
        />

        <CustomizableTextField
          id="article-volume-number"
          fieldOption="volumeNumber"
          xs={6}
          sm={6}
          md={4}
          defaultLabel={t(
            "file_details.volume_number",
            "Volume Number (optional)"
          )}
          value={path(["volumeNumber"], fields) || ""}
          onChange={onFieldChange(["volumeNumber"])}
          error={hasError(errors, "volumeNumber")}
          helperText={t(firstError(errors, "volumeNumber"))}
          onBlur={onBlur("volumeNumber", fields.volumeNumber)}
          inputProps={{ maxLength: 100, id: "article-volume-number" }}
        />

        <CustomizableSelect
          xs={12}
          sm={12}
          md={6}
          fieldOption="language"
          defaultLabel={t("file_details.language", "Language")}
          value={fields.language || ""}
          onChange={onFieldChange(["language"])}
        >
          {languages.map(lang => (
            <MenuItem key={lang.code} value={lang.code}>
              {lang.translation}
            </MenuItem>
          ))}
        </CustomizableSelect>

        <PublicationDate />

        <CustomizableRichTextField
          id="description"
          fieldOption="description"
          xs={12}
          sm={12}
          md={12}
          defaultLabel={t("file_details.description", "Description")}
          value={path(["descriptionText"], fields) || ""}
          onChange={({ text, html }) => {
            if (text === "") {
              onFieldChange(["description"])("");
              onFieldChange(["descriptionText"])("");
            } else {
              onFieldChange(["description"])(text);
              onFieldChange(["descriptionText"])(html);
            }
          }}
          error={hasError(errors, "description")}
          helperText={t(firstError(errors, "description"))}
          onBlur={onBlur("description", fields.description)}
        />
      </Grid>
    </Fragment>
  );
};

export default ArticleDetailsFields;
